import React from 'react';
// import { connect } from 'react-redux';
import injectSheet from 'react-jss';

import { compose } from 'shared/helpers';
import { BASE_COLOR } from 'shared/constants/colors';

import { mixClasses as cx } from 'helpers';

// import { Link } from 'components/elems';


// function mapStateToProps(state) {
//   return {
//     footerViewState: state.view.get('footer'),
//   };
// }
//
//
/*
 * Footer
 */
// const Footer = ({
//   classes: cn,
//   footerViewState,
// }) => {
//   // TODO: Put back footer when ready.
//   if (true) { return null; }
//
//   const footerIsVisible = footerViewState.get('isVisible');
//   if (!footerIsVisible) {
//     return null;
//   }
//
//   return (
//     <div className={cx(
//       cn.root,
//       'flex items-center justify-between moa-ff-sans f6 pa2 ph4-m ph5-l'
//     )}>
//       <div className={cx(cn.lhs, 'tracked')}>
//         <Link type="footer" to="/about/this">what + why</Link>
//         <Link type="footer" to="/about/us">who</Link>
//         <Link type="footer" to="/changelog">changelog</Link>
//       </div>
//       <div className={cx(cn.rhs, 'black-30')}>
//         <span>MADE IN NYC</span>
//         <span className={cx('mh2')}>~</span>
//         <span>© 2017 MOAGRAPH</span>
//       </div>
//     </div>
//   );
// };
// const styles = {
//   root: {
//     fontSize: '12px',  // Extra small, than tachyons can support.
//     height: '160px',  // Hardcoded..
//     borderTop: `2px solid ${BASE_COLOR.white}`,
//     // background: MOA_COLOR.magnet.outerSpace,
//     background: `linear-gradient(125deg, ${BASE_COLOR.nearBlack}, #dadada)`,
//   },
//   lhs: {
//     color: BASE_COLOR.moonGray,
//     '& > a': {
//       marginRight: '2.5rem',
//     },
//   },
//   rhs: {
//     // color: BASE_COLOR.darkGray,
//   }
// };
//
// // Maybe bottom part.. like warby parker.
// // height: 192px; background: linear-gradient(16deg, #ffffff, #d0d0d0);
//
//
// export default compose(
//   connect(mapStateToProps),
//   injectSheet(styles),
// )(Footer);



// TODO: Probably in desktop use fixed right aligned footer,
// but switch to normal one in mobile..?

/*
 * Footer
 */
const Footer = ({ classes: cn }) => {
  return (
    <div className={cx(
      cn.root,
      "moa-ff-sans moon-gray",
      "dn db-ns"
    )}>
      <span className="f6 mr2">
        <span className="moa-ff-argent">
          Moagraph
        </span>
        <span>
          ________
        </span>
      </span>
    </div>
  );
};

const styles = {
  root: {
    position: 'fixed',
    transform: 'rotate(-90deg)',
    right: '-53px',
    bottom: '53px',
    // background: 'red', // For debug

    // Use it to align against right side
    paddingBottom: '2rem',
    paddingLeft: '2rem',

    '& > span:not(:first-child)': {
      fontSize: '11px',  // To balance against moagraph argent ff
      letterSpacing: '.1em',        // .tracked
      textTransform: 'uppercase',   // .ttu
      marginLeft: '20px',
      transition: 'color 200ms',
    },
    '& > span:not(:first-child):hover': {
      color: BASE_COLOR.darkGray,
    },
    '& > span:not(:first-child):before': {
      content: '"/"',
      marginRight: '2px',
      color: BASE_COLOR.lightGray,
    },
  },
};

export default compose(
  injectSheet(styles),
)(Footer);



// WEBPACK FOOTER //
// ./src/components/navs/Footer.js